import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label question-label-project2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "mt-8 justify-items-stretch flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: "mt-4",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (option, key) => {
                return (_openBlock(), _createBlock(_component_ActionButton, {
                  key: key,
                  class: "mb-4",
                  selected: _ctx.state.answers.value?.[_ctx.config.answerKey] === key,
                  "button-class": "answer-button answer-button-project2",
                  onClick: ($event: any) => (_ctx.answer(key, {[key]: _ctx.$t(option)})),
                  rawtext: _ctx.$t(option)
                }, null, 8, ["selected", "onClick", "rawtext"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-4 h-full min-h-50vh flex-col items-center flex",
            style: _normalizeStyle(`background: ${_ctx.config.bgImage} center center no-repeat;
             background-size: contain; ${_ctx.config.bgStyles}`)
          }, null, 4)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}